import { AxiosError, isAxiosError } from 'axios';

interface ISignInRateLimitedResponse {
  message?: string;
  error?: string;
}

export class SignInRateLimitedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SignInRateLimitedError';
  }

  static fromAxiosError(error: unknown): SignInRateLimitedError | null {
    if (!isAxiosError(error)) {
      return null;
    }

    const axiosError = error as AxiosError<ISignInRateLimitedResponse>;

    if (axiosError.response?.status === 429) {
      const message =
        axiosError.response.data?.message ||
        axiosError.response.data?.error ||
        'Too many attempts, please try again in a few minutes.';
      return new SignInRateLimitedError(message);
    }

    return null;
  }
}
